import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import React, {memo, useCallback} from "react"
import {useLocalization} from "../../../../hooks/localization"
import {useDispatch, useSelector} from "react-redux"
import {useRPC} from "../../../../hooks/rpc"
import {useQuestion} from "../../../../hooks/question"
import {changeBusyAction} from "../../../../store/ui/actions"
import {useMessage} from "../../../../hooks/message"
import "./index.scss"

export const LanguageListScreen = memo(function LanguageListScreen() {
    const languageList = useSelector(state => state.control.languageList)
    const [rpc] = useRPC()
    const question = useQuestion()
    const dispatch = useDispatch()
    const {failure} = useMessage()
    const {changeLanguage, t} = useLocalization()

    const onClickChangeLanguage = useCallback(
        (id: string) => {
            question(t("are_you_sure"), () => {
                dispatch(changeBusyAction(true))
                rpc.setLanguage({selected_language: id})
                    .then(() => {
                        const timer = setTimeout(() => {
                            changeLanguage(id)
                            dispatch(changeBusyAction(false))
                            window.location.reload()
                        }, 1500)
                        return () => clearTimeout(timer)
                    })
                    .catch(failure)
                    .finally(() => dispatch(changeBusyAction(false)))
            })
        },
        [changeLanguage, t, dispatch, question, failure, rpc]
    )

    return (
        <PasswordContainer requiredRole="user" isFullscreen={true}>
            <SettingsPageContainer className="language-screen" buttons={[]} title={t("language")} backUrl={"/settings"}>
                <div className="content-divider">
                    <div className="content-wrapper">
                        <div className="language-options">
                            {languageList.map(language => (
                                <button className="language-btn" onClick={() => onClickChangeLanguage(language.id)}>
                                    <span>{language.name}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
